import React, { useEffect, useState } from "react";
import axiosConfig from "../../axiosConfig";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Divider from "@material-ui/core/Divider";
import Button from "@material-ui/core/Button";
import { useHistory } from "react-router-dom";
import AutoComplete from "@material-ui/lab/Autocomplete";
import { useFormik } from "formik";
import * as Yup from "yup";
import Swal from "sweetalert2";
import Loading from "../Loading/loading";
import axios from "axios";
import { swalSubmit } from "../../shared/swalSubmit";
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  makeStyles,
} from "@material-ui/core";
import {
  Card as Card2,
  CardHeader as CardHeader2,
  CardBody,
} from "../../shared/Card/Index";
import styles from "../../shared/dashboardStyle";
import * as headers from "../../shared/language.json";
import * as regEx from "../../shared/regularExpressions";

const useStyles = makeStyles(styles);

function EditManagementUser(props) {
  const [roles, setRoles] = useState([]);
  const [initialRole, setInitialRole] = useState();
  const [loading, setLoading] = useState(true);

  let history = useHistory();
  const classes = useStyles();





  useEffect(() => {
    if (typeof props.location.selected != "undefined") {
      const promise1 = axiosConfig.get(`/Role`);

      const promise2 = axiosConfig.get(
        `/User/GetUserById/${props.location.selected}`
      );
      axios
        .all([promise1, promise2])
        .then(
          axios.spread((...res) => {
            const rolesData = res[0];
            setRoles(rolesData.data);
            const userData = res[1];
            formik.setValues(userData.data);
            setInitialRole({
              id: userData.data.roleID,
              description: userData.data.role,
            });
            setLoading(false);
          })
        )
        .catch((err) => {
          console.log(err);
        });
    } else {
      history.goBack();
    }
  }, []);

  const handleSubmit = () => {
    Swal.fire({
      title: "",
      text: `Έχετε επιλέξει να πραγματοποιήσετε αποστολή προσωρινού κωδικού στο Χειριστή με username ${formik.values.email}. Είστε βέβαιοι;`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Ναι",
      cancelButtonText: "Οχι",
      showLoaderOnConfirm: true,
      closeOnClickOutside: false,
      preConfirm: () => {
        Swal.fire(swalSubmit).then((result) => {
          if (result.isConfirmed) {
            let email = formik.values.email;
            return axiosConfig.put(`/User/SendTemporaryPassword/${email}`).catch((error) => {
              Swal.fire("Η καταχώρηση ήταν ανεπιτυχής", "", "error");
            });
          }
        })
      },
      allowOutsideClick: () => !Swal.isLoading(),
    });
  };

  const formik = useFormik({
    initialValues: {
      id: 0,
      email: "",
      firstname: "",
      lastname: "",
      roleID: "",
      role: "",
    },
    validationSchema: Yup.object({
      firstname: Yup.string()
        .matches(
          regEx.nameRegexGreekOnly,
          headers.FORMIKERRORMESSAGES.GREEKONLYANDFIRSTLETTERCAPITAL
        )
        .min(3, headers.FORMIKERRORMESSAGES.ATLEASTTHREECHARACTERS)
        .max(30, headers.FORMIKERRORMESSAGES.THIRTYCHARACTERSMAX)
        .required(headers.FORMIKERRORMESSAGES.REQUIRED),
      lastname: Yup.string()
        .matches(
          regEx.nameRegexGreekOnly,
          headers.FORMIKERRORMESSAGES.GREEKONLYANDFIRSTLETTERCAPITAL
        )
        .min(3, headers.FORMIKERRORMESSAGES.ATLEASTTHREECHARACTERS)
        .max(30, headers.FORMIKERRORMESSAGES.THIRTYCHARACTERSMAX)
        .required(headers.FORMIKERRORMESSAGES.REQUIRED),
    }),
    onSubmit: (values) => {
      Swal.fire({
        title: "",
        text: `Έχετε επιλέξει να πραγματοποιήσετε αλλαγή στο Χειριστή με username ${values.email}. Είστε βέβαιοι;`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ναι",
        cancelButtonText: "Οχι",
        showLoaderOnConfirm: true,
        closeOnClickOutside: false,
        preConfirm: () => {
          Swal.fire(swalSubmit).then((result) => {
            if (result.isConfirmed) {
              return axiosConfig
                .put(`/User/UpdateUserByAdmin`, {
                  id: values.id,
                  firstname: values.firstname,
                  lastname: values.lastname,
                  roleId: values.roleId,
                })
                .then((response) => {
                  history.push("/all-users");
                })
                .catch((error) => {
                  Swal.showValidationMessage(`Η καταχώρηση ήταν ανεπιτυχής`);
                });
            }
          })
        },
        allowOutsideClick: () => !Swal.isLoading(),
      });
    },
  });

  if (loading === false) {
    return (
      <form className="Form">
        {/* <Container maxWidth="lg"> */}
        <Card2>
          <CardHeader2 color="warning">
            <h1 className={classes.cardTitleWhite}>Επεξεργασία Χειριστή</h1>
          </CardHeader2>
          <CardBody>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={12} md={6}>
                <Box mt={3}>
                  <Card>
                    <CardHeader
                      subheader="Τα παρακάτω πεδία δεν γίνεται να τροποποιηθούν."
                      title="Στοιχεία Χειριστή"
                    />
                    <Divider />
                    <CardContent>
                      <Grid container spacing={6} wrap="wrap">
                        <Grid item xs={12} sm={12} md={12}>
                          <TextField
                            type="email"
                            required
                            id="email"
                            name="email"
                            label="Email"
                            variant="outlined"
                            fullWidth
                            disabled
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.email}
                          />
                          {formik.touched.email && formik.errors.email ? (
                            <span style={{ color: "red" }}>
                              {formik.errors.email}
                            </span>
                          ) : null}
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                </Box>
              </Grid>
              <Grid item xs={12} sm={12} md={6}>
                <Box mt={3}>
                  <Card>
                    <CardHeader
                      // subheader="Τα παρακάτω πεδία δεν γίνεται να τροποποιηθούν."
                      title="Επεξεργασία Στοιχείων"
                    />
                    <Divider />
                    <CardContent>
                      <Grid container spacing={6} wrap="wrap">
                        <Grid item xs={12} sm={12} md={12}>
                          <TextField
                            id="firstname"
                            name="firstname"
                            label="Όνομα"
                            type="text"
                            variant="outlined"
                            fullWidth
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.firstname}
                          />
                          {formik.touched.firstname &&
                            formik.errors.firstname ? (
                            <span style={{ color: "red" }}>
                              {formik.errors.firstname}
                            </span>
                          ) : null}
                        </Grid>
                        <Grid item xs={12} sm={12} md={12}>
                          <TextField
                            id="lastname"
                            name="lastname"
                            label="Επώνυμο"
                            type="text"
                            variant="outlined"
                            fullWidth
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.lastname}
                          />
                          {formik.touched.lastname && formik.errors.lastname ? (
                            <span style={{ color: "red" }}>
                              {formik.errors.lastname}
                            </span>
                          ) : null}
                        </Grid>
                        <Grid item xs={12} sm={12} md={12}>
                          <AutoComplete
                            onChange={(event, newValue) => {
                              if (newValue === null) {
                                formik.setFieldValue("roleId", "");
                              } else {
                                formik.setFieldValue("roleId", newValue.id);
                              }
                            }}
                            defaultValue={initialRole}
                            options={roles}
                            getOptionLabel={(option) => option.description}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Ρόλος . . ."
                                variant="outlined"
                                name="roleId"
                              />
                            )}
                          />
                          {formik.touched.roleId && formik.errors.roleId ? (
                            <span style={{ color: "red" }}>
                              {formik.errors.roleId}
                            </span>
                          ) : null}
                        </Grid>
                      </Grid>
                    </CardContent>
                    <Divider />
                    <Box display="flex" justifyContent="flex-end" p={2}>
                      <Button
                        type="button"
                        variant="contained"
                        color="primary"
                        style={{ marginRight: "1vw" }}
                        onClick={handleSubmit}
                      >
                        Προσωρινος Κωδικος
                      </Button>
                      <Button
                        type="button"
                        variant="contained"
                        color="primary"
                        onClick={formik.handleSubmit}
                      >
                        Αποθηκευση
                      </Button>
                    </Box>
                  </Card>
                </Box>
              </Grid>
            </Grid>
          </CardBody>
        </Card2>

        {/* </Container> */}
      </form>
    );
  } else {
    return <Loading />;
  }
}

export default EditManagementUser;
